import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EngineeringHero from "./sections/EngineeringHero";
import Domotica from "./sections/Domotica";
import PrecisionServices from "./sections/PrecisionServices";
import Trabajos from "./sections/Trabajos";
import Satisfaccion from "./sections/Satisfaccion";
import Reviews from "./sections/Reviews";
import Presupuesto from "./sections/Presupuesto";
import PresupuestoGratuitoRespuestaRPida from "./sections/PresupuestoGratuitoRespuestaRPida";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EngineeringHero />
      <Domotica />
      <PrecisionServices />
      <Trabajos />
      <Satisfaccion />
      <Reviews />
      <Presupuesto />
      <PresupuestoGratuitoRespuestaRPida />
      <Footer />
    </div>;
}